<template>
  <div class="ActCompanyPayDialog">
<!--    <div v-show="isShowDialog"-->
<!--      class="ActCompanyPayBar"-->
<!--    >-->
<!--      <div slot="modal_content"-->
<!--           class="modal_content"-->
<!--        @click="toPay"-->
<!--      >-->
<!--        <i class="icon_close" @click.stop="closeDialog"></i>-->
<!--        <i class="icon_lq anima"></i>-->
<!--      </div>-->
<!--    </div>-->

    <a class="ActCompanyPayBar" v-if="isShowDialog"
       href="/act/newYear"
       target="_blank"
    >
      <div class="inner_center">
        <i class="iconfont icon-cha" @click.stop.prevent="closeDialog" />
      </div>
    </a>

    <!-- 小标 -->

    <div class="fb-box"
         v-show="isShowFB2"
         @click="toPay2"
    >

<!--      <div class="times">-->
<!--        {{ times.h }}:{{ times.m }}:{{ times.s }}:{{ times.hm }}-->
<!--      </div>-->

      <i class="iconfont icon-cha2"
         @click.stop="closeFb"
      ></i>

    </div>
  </div>

</template>

<script>

import {fnLocalStorage, fnLogin, fnRouter} from "@/fn";
import {MODEL_ACT_618, MODEL_ACT_COMPANY_PAY, MODEL_ACT_COMPANY_PAY_FB} from "@/constant/MODELS";
import {PAGE_PATH} from "@/constant/PAGE_PATH";
import {mapState} from "vuex";
import {tag} from "@/utils/statUtil";
import {PAY_COMPANY_NEW} from "@/constant/_Public/Path";

export default {
  name: "ActCompanyPayDialog",
  data(){
    return{
      times:{},
      isShowDialog: false,
      isShowFB: false,
      isShowFB2: true,
      PAY_COMPANY_NEW
    }
  },
  async mounted() {
    // setInterval(() => {
    //   this.times = this.getCurrDayCountdown();
    // }, 1)

    this.check();

  },
  computed: {
    ...mapState('user',
      ['isLogin']
    ),
  },

  watch:{
    isLogin:{
      handler(n,o){
        if (n == true){
          this.check();
        }
      }
    }
  },
  methods:{

    check(){
      if (fnLogin.checkLogin()){
        if (!fnLocalStorage.getItemDate(MODEL_ACT_COMPANY_PAY)){
          this.isShowDialog = true
        }else{
          this.isShowDialog = false
        }

        if (!fnLocalStorage.getItemDate(MODEL_ACT_COMPANY_PAY_FB)){
          this.isShowFB = true
        }else{
          this.isShowFB = false
        }
      }
    },
    closeDialog(){
      this.isShowDialog = false;
      fnLocalStorage.setItemDate(MODEL_ACT_COMPANY_PAY,1);
      this.isShowFB = true;
    },
    closeFb(){
      this.isShowFB2 = false
      // fnLocalStorage.setItemDate(MODEL_ACT_COMPANY_PAY,1);
      // fnLocalStorage.setItemDate(MODEL_ACT_COMPANY_PAY_FB,1);
    },
    getCurrDayCountdown() {
      let now = new Date(); // 获取当前时间
      let hour = now.getHours(); // 时
      let min = now.getMinutes(); // 分
      let sec = now.getSeconds(); // 秒
      let hm = now.getMilliseconds(); // 秒
      hm = hm.toString().substr(0,1)

      let h = 24 - hour; // 倒计时 时
      if (min > 0 || sec > 0) {
        h -= 1
      }
      let m = 60 - min; // 倒计时 分
      if (sec > 0) {
        m -= 1
      }
      if (m == 60) {
        m = 0
      }
      let s = 60 - sec; // 倒计时 秒
      if (s == 60) {
        s = 0
      }

      h = h.toString();
      m = m.toString();
      s = s.toString();
      if (h.length == 1) {
        h = '0' + h
      }
      if (m.length == 1) {
        m = '0' + m
      }
      if (s.length == 1)
        s = '0' + s
      var result = h + ':' + m + ':' + s
      // this.h = h;
      // this.m = m;
      // this.s = s;
      return {
        h,
        m,
        s,
        hm
      }
    },

    toPay(){
      tag('充值:企业650活动:图片');
      this.closeDialog();
      let path = PAGE_PATH.PAYMENT.ACT_COMPANY_PAY;
      fnRouter.navigationTo(path)
    },
    toPay2(){
      let path = PAGE_PATH.PAYMENT.ACT_COMPANY_PAY;
      fnRouter.navigationTo(PAY_COMPANY_NEW)
    }
  }
}
</script>

<style lang="scss" scoped>
.ActCompanyPayDialog{

  .modal_content{
    @include BgImage(523px,555px, 'pay/act-company/dialog-bg.png');
    position: relative;
  }

  .icon_close{
    @include BgImage(20px,20px, 'pay/act-company/icon_close.png');
    @include Position(1,2,30px,90px);
    cursor: pointer;
  }

  .icon_lq{
    @include BgImage(269px,109px, 'pay/act-company/lq.png');
    @include Position(1,4,126px,20px);
    //transform: translateX(-50%);
  }



}

@keyframes slide {
  0% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(20px);
  }
  100% {
    transform: translateY(0);
  }
}

.fb-box{
  @include BgImage(221px,278.5px, 'pay/act-company/fb-bg22.png');
  position: fixed;
  right: 50px;
  z-index: 99;
  bottom: 220px;
  cursor: pointer;
  animation: slide 2s ease-in-out infinite;


  .times{
    display: inline-block;
    font-size: 12px;
    font-weight: 400;
    color: #A01507;
    text-align: center;
    @include Position(1,5,50%,52px);
    transform: translateX(-50%);
    white-space: nowrap;
  }

  .icon-cha2{
    //@include BgImage(20px,20px, 'pay/act-company/icon_close2.png');
    //@include Position(1,2,50%,120px);
    //transform: translateX(50%);
    //cursor: pointer;
    width: 20px;
    height: 20px;
    font-size: 20px;
    color: white;
    display: inline-block;
    //background: url("//js.chaopx.com/chaotu/pay/act-company/icon_close2.png") no-repeat center/100%;
    vertical-align: middle;
    position: absolute;
    right: 44%;
    top: 242px;
    transform: translateX(50%);
    cursor: pointer;
  }
}

.anima {animation-name: likes; // 动画名称
 animation-direction: alternate; // 动画在奇数次（1、3、5...）正向播放，在偶数次（2、4、6...）反向播放。
 animation-timing-function: linear; // 动画执行方式，
 linear:ease-in-out; // 由慢速开始和结束；
 animation-delay: 0s; // 动画延迟时间
 animation-iteration-count: infinite; //  动画播放次数，infinite：一直播放
 animation-duration: 1s; // 动画完成时间
}
@keyframes likes {0%{transform: scale(1);}25%{transform: scale(0.9);}50%{transform: scale(0.85);}75%{transform: scale(0.9);}100%{transform: scale(1);}}




.ActCompanyPayBar{
  width: 100%;
  height: 60px;
  display: block;
  transition: all 0.8s ease;
  //@include BgImage2(100%,60px,"act/618/actBar.png", 1);
  @include BgImage(100%, 97px, 'act/guoqing/pay_bar2.png', 1);
  vertical-align: middle;
  position: fixed;
  bottom: 0;
  z-index: 10;
  background-size: 1920px 97px;


  .inner_center{
    height: 100%;
    position: relative;
  }

  .icon-cha {
    width: 24px;
    height: 24px;
    background: rgba(0, 0, 0, 0.2);
    @include Position(1, 2, 0, 62%);
    transform: translateY(-50%);
    color: #FFFFFF;
    line-height: 24px;
    text-align: center;
    cursor: pointer;
    border-radius: 50%;
    font-size: 14px;
    @include ElementHover('', rgba(0, 0, 0, 0.3))
  }
}
</style>
